export default function StakeholderImpact() {
  const impactOnCompanies = [
    { icon: 'ri-search-eye-line', title: 'اكتشاف مواهب مبكرًا', description: 'الوصول للمواهب قبل المنافسين' },
    { icon: 'ri-lightbulb-flash-line', title: 'تعزيز الابتكار', description: 'الاستفادة من أفكار الشباب المبتكرة' },
    { icon: 'ri-heart-3-line', title: 'مسؤولية اجتماعية ذكية', description: 'تحقيق أهداف CSR بشكل فعال' },
    { icon: 'ri-user-add-line', title: 'المساهمة في حل مشكلة البطالة', description: 'دعم التوظيف وتطوير الكفاءات' }
  ];

  const communityImpact = [
    { icon: 'ri-arrow-down-line', title: 'تقليل البطالة', description: 'خلق فرص عمل وتطوير مهارات الشباب' },
    { icon: 'ri-book-open-line', title: 'دعم الاقتصاد المعرفي', description: 'بناء اقتصاد قائم على المعرفة والابتكار' },
    { icon: 'ri-flag-line', title: 'تعزيز ثقافة المبادرة', description: 'نشر ثقافة ريادة الأعمال والابتكار' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-white via-gray-50 to-white relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-20 w-72 h-72 bg-[#FFB88C]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-[#FFA07A]/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        {/* Impact on Companies */}
        <div className="mb-24">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              الأثر على الجهات
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              القيمة الاستراتيجية للجهات الراعية
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {impactOnCompanies.map((impact, index) => (
              <div
                key={index}
                className="group bg-white p-8 rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#FFB88C] to-[#FFA07A] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${impact.icon} text-white text-3xl`}></i>
                </div>
                <h4 className="font-bold text-xl text-gray-900 mb-3">
                  {impact.title}
                </h4>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {impact.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Community Impact */}
        <div>
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              الأثر المجتمعي
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              التأثير الإيجابي على المجتمع والاقتصاد
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {communityImpact.map((impact, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-gray-900 to-gray-800 text-white p-10 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${impact.icon} text-white text-3xl`}></i>
                </div>
                <h4 className="font-bold text-2xl mb-4">
                  {impact.title}
                </h4>
                <p className="text-gray-300 leading-relaxed">
                  {impact.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
